import React from 'react'
import { CleartripTransactions } from '@/src/components/common/wallet/cleartripTransactions'
import type { CleartripFormattedTransaction } from '@/src/components/common/wallet/cleartripTransactions/cleartripTransactions'
import WalletEmptyStateWrapper from '@/src/components/common/wallet/walletEmptyState'
import { WalletDesktopPage } from './wallet'

type WalletDesktopPageProps = Omit<React.ComponentProps<typeof WalletDesktopPage>, 'isCleartrip'>

interface WalletDesktopCleartripContentProps {
    walletPageProps: WalletDesktopPageProps
    transactions: CleartripFormattedTransaction[]
    hasMoreTransactions: boolean
    isFetchingMore: boolean
    onLoadMore: () => void
    formatAmount: (amount: number, currency: string) => string
    transactionHistoryLabel: string
    noTransactionsLabel: string
    loadMoreLabel: string
    loadingLabel: string
    transactionIdLabel: string
}

const WalletDesktopCleartripContent = ({
    walletPageProps,
    transactions,
    hasMoreTransactions,
    isFetchingMore,
    onLoadMore,
    formatAmount,
    transactionHistoryLabel,
    noTransactionsLabel,
    loadMoreLabel,
    loadingLabel,
    transactionIdLabel
}: WalletDesktopCleartripContentProps) => {
    return (
        <>
            <WalletDesktopPage {...walletPageProps} isCleartrip />
            {transactions.length === 0 ? (
                <WalletEmptyStateWrapper />
            ) : (
                <CleartripTransactions
                    transactions={transactions}
                    hasMoreTransactions={hasMoreTransactions}
                    isFetchingMore={isFetchingMore}
                    onLoadMore={onLoadMore}
                    formatAmount={formatAmount}
                    transactionHistoryLabel={transactionHistoryLabel}
                    noTransactionsLabel={noTransactionsLabel}
                    loadMoreLabel={loadMoreLabel}
                    loadingLabel={loadingLabel}
                    transactionIdLabel={transactionIdLabel}
                    isRtl={walletPageProps.isRtl}
                />
            )}
        </>
    )
}

export default WalletDesktopCleartripContent
